module.exports = __webpack_public_path__ + "static/media/ic_product_robotrader_info_two.e04a85d1.svg";